// Central content for the UNSTUCK site. Edit text, prices and collections here —
// the pages render from this file so future collections can be added without redesign.

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1764173039543-f9f197744e1b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxoYXBweSUyMGRpdmVyc2UlMjBvbGRlciUyMGFkdWx0cyUyMGNvbW11bml0eXxlbnwwfHx8fDE3OTE4MzU2Mjd8MA&ixlib=rb-4.1.0&q=85",
  caregiver: "https://images.unsplash.com/photo-1765896387387-0538bc9f997e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxjYXJlZ2l2ZXIlMjBzZW5pb3IlMjB0YWxraW5nfGVufDB8fHx8MTc5MTgzNTYzMnww&ixlib=rb-4.1.0&q=85",
  group: "https://images.unsplash.com/photo-1513159446162-54eb8bdaa79b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxzZW5pb3JzJTIwcGxheWluZyUyMGdhbWUlMjB0b2dldGhlcnxlbnwwfHx8fDE3OTE4MzU2MzJ8MA&ixlib=rb-4.1.0&q=85",
  independent: "https://images.unsplash.com/photo-1758691031958-29541f3207a5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHw0fHxzZW5pb3IlMjByZWFkaW5nJTIwaG9tZXxlbnwwfHx8fDE3OTE4MzU2MzJ8MA&ixlib=rb-4.1.0&q=85",
};

// Prices shown on the site. Set a number to make an item buyable — the same
// price must exist in the Stripe catalog (setup_stripe.py). null = "Price TBD".
export const PRICES = {
  seniorsProgram: 179.0,
  seniorsDeck: 34.99,
  extraBucks: 7.99,
};

// Extra UNSTUCK Bucks — a separate purchasable item (part of the optional reward system).
export const EXTRA_BUCKS = {
  name: "Extra UNSTUCK Bucks",
  lookupKey: "extra_bucks",
  price: 7.99,
};

export const WAYS_TO_PLAY = [
  {
    name: "PULL IT",
    text: "Pull one card and complete the activity on your own for up to 15 minutes.",
  },
  {
    name: "PASS IT",
    text: "Complete a card, then pass another card to a friend, resident, family member, or participant to encourage engagement.",
  },
  {
    name: "TRADE IT",
    text: "Two people can each pull a card and choose to trade cards before completing their activities.",
  },
  {
    name: "EARN IT",
    text: "Complete activities and optionally use the UNSTUCK Bucks reward system.",
  },
];

export const UNSTUCK_BUCKS = [
  { amount: "$1", label: "SHOWED UP" },
  { amount: "$5", label: "KEEP GOING" },
  { amount: "$10", label: "GREAT DAY" },
  { amount: "$20", label: "BIG RESET" },
];

export const HOW_IT_WORKS = [
  {
    step: 1,
    title: "Pull one card",
    text: "Choose one simple activity.",
  },
  {
    step: 2,
    title: "Give it up to 15 minutes",
    text: "The activity may take less or more time, but 15 minutes is the basic reset window.",
  },
  {
    step: 3,
    title: "Do what the card says",
    text: "Complete the activity at your own pace.",
  },
  {
    step: 4,
    title: "One small step counts",
    text: "There is no pressure to race, compete, or be perfect.",
  },
];

export const SENIORS_AUDIENCE = [
  "Older adults living independently",
  "Residents in assisted living or senior communities",
  "Caregivers",
  "Family members",
  "Senior centers",
  "Housing authorities",
  "Activity directors",
  "Senior program staff",
  "Small groups",
];

export const GIFT_AUDIENCES = [
  "Seniors",
  "Parents and grandparents",
  "Teenagers",
  "Couples",
  "Dads",
  "Families",
  "Caregivers",
  "Content creators",
];

// Real product photos supplied by the owner (stored in /public/images).
export const SENIORS_DECK_IMAGE = "/images/seniors-deck.png";
export const SENIORS_KIT_IMAGE = "/images/seniors-kit.png";
export const SENIORS_IN_USE_IMAGE = "/images/seniors-in-use.png";
export const CREATOR_IMAGE = "/images/creator.png";
export const BUCKS_IMAGE = "/images/bucks-sheet.png";

// The 8 additional collections. price: null means the price has not been set yet —
// the tile shows an editable "pricing coming soon" area instead of an invented number.
export const COLLECTIONS = [
  {
    id: "original-reset",
    lookupKey: "original_reset",
    name: "Original Reset",
    price: 34.99,
    image: "/images/original-reset-deck.png",
    short: "A general 15-minute reset deck for everyday life.",
    long: "A general 15-minute reset deck for everyday life, routines, home, mind, nourishment, family, dreams, and getting unstuck.",
  },
  {
    id: "kids",
    lookupKey: "kids",
    name: "Kids",
    price: 34.99,
    image: "/images/kids-deck.png",
    short: "Simple activities made for kids.",
    long: "Simple activities for feelings, creativity, movement, learning, kindness, outdoor time, helping at home, and calming down.",
  },
  {
    id: "teen-boys",
    lookupKey: "teen_boys",
    name: "Teen Boys",
    price: 34.99,
    image: "/images/teen-boys-deck.png",
    short: "Everyday activities built for teen boys.",
    long: "Activities around hygiene and self-care, school and study habits, family and responsibility, kindness and service, money and work ethic, health and fitness, leadership and communication, faith and character.",
  },
  {
    id: "teen-girls",
    lookupKey: "teen_girls",
    name: "Teen Girls",
    price: 34.99,
    image: "/images/teen-girls-deck.png",
    short: "Everyday activities built for teen girls.",
    long: "Activities focused on hygiene, school, family, kindness, life skills, confidence, boundaries, and faith.",
  },
  {
    id: "content-creator",
    lookupKey: "content_creator",
    name: "Content Creator",
    price: 34.99,
    image: "/images/content-creator-deck.png",
    short: "Simple prompts and resets for creators.",
    long: "Simple prompts and resets designed to help creators get organized, create consistently, plan content, and move forward when they feel stuck.",
  },
  {
    id: "dads",
    lookupKey: "dads",
    name: "Dad",
    price: 34.99,
    image: "/images/dads-deck.png",
    short: "Practical 15-minute prompts for fatherhood.",
    long: "Practical 15-minute prompts designed around fatherhood, responsibility, connection, self-care, home life, and everyday progress.",
  },
  {
    id: "family",
    lookupKey: "family",
    name: "Family",
    price: 34.99,
    image: "/images/family-deck.png",
    short: "Simple activities families can share.",
    long: "Simple activities families can use to connect, communicate, help one another, build routines, and spend meaningful time together.",
  },
  {
    id: "couples",
    lookupKey: "couples",
    name: "Couples",
    price: 34.99,
    image: "/images/couples-deck.png",
    short: "Activities centered on connection.",
    long: "Activities centered on connection, communication, fun, appreciation, teamwork, romance, growth, and everyday life.",
  },
];

export const FAQ_ITEMS = [
  {
    q: "What is UNSTUCK?",
    a: "UNSTUCK is a collection of simple 15-minute activity decks designed to help people take one small action when they feel stuck, bored, overwhelmed, disconnected, or unsure where to begin. Each card offers one everyday action — like cleaning your glasses, organizing a small space, drinking water, or starting a conversation — to help you start, participate, engage, and build momentum one manageable step at a time.",
  },
  {
    q: "Why are the activities so simple?",
    a: "The activities are intentionally simple because the goal is to help someone start. A prompt may seem small, but a small action can create momentum for the rest of the day. There is no pressure to race, compete, or be perfect — one small step counts.",
  },
  {
    q: "Does every activity take exactly 15 minutes?",
    a: "No. An activity may take less or more time — 15 minutes is simply the basic reset window. You complete each activity at your own pace.",
  },
  {
    q: "Can someone use UNSTUCK alone?",
    a: "Yes. UNSTUCK Seniors is individual-first — a senior does not have to participate in a group to use it. The deck can be used alone, with a caregiver or family member, with another resident, or in a group setting.",
  },
  {
    q: "Can it be used in assisted living?",
    a: "Yes. UNSTUCK Seniors is designed for residents in assisted living or senior communities, as well as older adults living independently. Activity directors and senior program staff can use it with individuals or small groups.",
  },
  {
    q: "Can caregivers use it?",
    a: "Yes. A caregiver or family member can share a card with the person they support, complete an activity together, or use the deck to spark conversation and participation.",
  },
  {
    q: "Can groups use it?",
    a: "Yes. UNSTUCK can be used solo, caregiver-assisted, partner-to-partner, or in groups — including small groups at senior centers and community programs.",
  },
  {
    q: "What are the 4 ways to play?",
    a: "PULL IT — pull one card and complete the activity on your own for up to 15 minutes. PASS IT — complete a card, then pass another card to a friend, resident, family member, or participant. TRADE IT — two people each pull a card and choose to trade before completing their activities. EARN IT — complete activities and optionally use the UNSTUCK Bucks reward system.",
  },
  {
    q: "What are UNSTUCK Bucks?",
    a: "UNSTUCK Bucks are an optional motivational reward system — they are not real money. The current designs are $1 SHOWED UP, $5 KEEP GOING, $10 GREAT DAY, and $20 BIG RESET, each marked GAME USE ONLY • NO CASH VALUE. Organizations or families choose their own rewards, and using the reward system is never mandatory.",
  },
  {
    q: "Can I buy only one Seniors deck?",
    a: "Yes. The Individual UNSTUCK Seniors Deck is a separate purchase option at $34.99 for customers who only want one deck or want to start smaller. The Complete UNSTUCK Seniors Program ($179 + shipping) is a separate offer.",
  },
  {
    q: "What comes in the full Seniors program?",
    a: "The Complete UNSTUCK Seniors Program includes four individually packaged 54-card UNSTUCK Seniors decks, printed instructions, UNSTUCK Bucks, printable PDF support materials (the instructions, printable Bucks, the Participation & Progress Tracker, and the Understanding Your Tracker guide), and program packaging.",
  },
  {
    q: "Are the cards downloadable PDFs?",
    a: "No. The printable PDFs included with the Seniors program are support materials for the instructions and UNSTUCK Bucks only. The physical activity cards themselves are not printable PDFs.",
  },
  {
    q: "Can people with limited mobility use UNSTUCK?",
    a: "Yes. Not every person can walk, exercise, stand for long periods, or use their hands the same way — so the deck includes a variety of simple prompts. Some involve movement, while others involve conversation, memory, hydration, reflection, choice, or everyday tasks. The purpose is to give more people a way to participate, feel included, and complete one manageable action at a time.",
  },
  {
    q: "When will my order ship?",
    a: "Physical orders are processed and shipped within 3–5 business days with flat $12.00 shipping per order. Digital products like Extra UNSTUCK Bucks are delivered by download immediately after payment — nothing ships.",
  },
  {
    q: "Can organizations order in bulk?",
    a: "Yes. Special organization pricing is available for orders of 10 or more programs. Visit the Organizations & Bulk Orders page to request a custom quote.",
  },
  {
    q: "Are other UNSTUCK decks available?",
    a: "Yes. In addition to UNSTUCK Seniors, the UNSTUCK family includes Original Reset, Kids, Teen Boys, Teen Girls, Content Creator, Dads, Family, and Couples. See them all on the Explore UNSTUCK Collections page.",
  },
];

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/seniors", label: "UNSTUCK Seniors" },
  { to: "/shop/seniors-deck", label: "Shop Individual Deck" },
  { to: "/collections", label: "Explore UNSTUCK Collections" },
  { to: "/organizations", label: "Organizations & Bulk Orders" },
  { to: "/try-free", label: "Free Trial" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];
